import { create } from "zustand";
import { caseSearch, fetchReturnOrdersData, getEngagementHourly, getReturnOrderDetails, ghostOrders, warehousePincode } from "../api_layer/api";
import {
  moveOrder,
  allOrders,
  orderDownload,
  postAssignOrder,
  updateOrder,
  openOrders,
  openOrdersDownload,
  recentOrderAssign,
  recentOrderData,
  assignedDoctors,
} from "../api_layer/api";
import { getReps, warehouseDownloadPincode } from "modules/case_management/api/api";

export const useOrderManagementStore = create((set) => ({
  caseData: [],
  caseDataTo: [],
  updateData: [],
  caseDataLoading: false,
  caseDataToLoading: false,
  updateLoading: false,
  error: null,
  fetchOrderCaseData: async (id, setToaster) => {
    if (id) {
      try {
        set({ caseDataLoading: true, error: null });
        const response = await caseSearch(id);
        if (response.data.length) {
          set({ caseData: response.data, caseDataLoading: false });
        } else {
          setToaster("Order movement", "No Data Available", "danger");
          set({caseDataLoading: false});
        }
      } catch (error) {
        set({ error: error.message, caseDataLoading: false });
      }
    } else {
      set({ caseData: [], caseDataLoading: false }); 
    }
  },

  fetchOrderCaseDataTo: async (id, setToaster) => {
    if (id) {
      try {
        set({ caseDataToLoading: true, error: null });
        const response = await caseSearch(id);
        if (response.data.length) {
          set({ caseDataTo: response.data, caseDataToLoading: false });
        } else {
          setToaster("Order movement", "No Data Available", "danger");
        }
      } catch (error) {
        set({ error: error.message, caseDataToLoading: false });
      }
    } else {
      set({ caseDataTo: [], caseDataToLoading: false });
    }
  },
  updateMoveOrder: async (payload, setToaster, setRefresh) => {
    try {
      set({ updateLoading: true, error: null });
      const response = await moveOrder(payload);
      set({ updateData: response.data, updateLoading: false });
      setToaster("Order Movement", "Order Moved Successfully", "success");
      setRefresh(1);
    } catch (error) {
      set({ error: error.message, updateLoading: false });
      setToaster("Order Movement", "Order Movement Failed", "danger");
      setRefresh(1);
    }
  },
}));

export const useAllOrderStore = create((set) => ({
  ordersData: [],
  medicalData: [],
  consultData: [],
  operationData: [],
  hourEngData:[],
  hourlyLoading:false,
  ordersLoading: false,
  medicalLoading: false,
  consultLoading: false,
  operationLoading: false,
  updateLoading: false,
  error: null,
  fetchAllOrder: async (query) => {
    try {
      set({ ordersLoading: true, error: null });
      const response = await allOrders(query);
      set({ ordersData: response.data, ordersLoading: false });
    } catch (error) {
      set({ error: error.message, ordersLoading: false });
    }
  },
  fetchMedicalRep: async () => {
    try {
      set({ medicalLoading: true, error: null });
      const response = await getReps("medical_rep");
      set({ medicalData: response.data, medicalLoading: false });
    } catch (error) {
      set({ error: error.message, medicalLoading: false });
    }
  },
  fetchConsultRep: async () => {
    try {
      set({ consultLoading: true, error: null });
      const response = await getReps("consult_rep");
      set({ consultData: response.data, consultLoading: false });
    } catch (error) {
      set({ error: error.message, consultLoading: false });
    }
  },
  fetchHourlyEng: async (startDate, endDate) => {
    try {
      set({ hourlyLoading: true, error: null });
      const response = await getEngagementHourly(startDate, endDate);;
      set({ hourEngData: response.data, hourlyLoading: false });
    } catch (error) {
      set({ error: error.message, hourlyLoading: false });
    }
  },
  fetchOperations: async () => {
    try {
      set({ operationLoading: true, error: null });
      const response = await getReps("operations");
      set({ operationData: response.data, operationLoading: false });
    } catch (error) {
      set({ error: error.message, operationLoading: false });
    }
  },
  fetchOrderDownload: async (queryParams, setToaster) => {
    try {
      const response = await orderDownload(queryParams);
      setToaster(
        "Order Download",
        "Email with Orders Attachment sent successfully",
        "success"
      );
    } catch (error) {
      setToaster("Order Download", "Orders download failed", "danger");
    }
  },
  postAssignData: async (payload, setToaster) => {
    const callFunction = payload?.map((item) => {
      return postAssignOrder(item);
    });
    try {
      Promise.all(callFunction)
        .then((data) => {
          setToaster(
            "Order Assigned",
            "Orders Assigned Successfully",
            "success"
          );
        })
        .catch((error) => {
          if (error.response.status) {
            setToaster(
              "Order Assignment",
              "One or more cases could not be assigned due to no available slots. The page will refresh with the latest data.",
              "danger"
            );
          } else {
            setToaster("Order Assignment", "Unable to assign", "danger");
          }
        });
    } catch (error) {
      set({ error: error.message, errorUpdate: true });
    }
  },
}));

export const useUpdateOrdersStore = create((set) => ({
  updateLoading: false,
  updateOrderStatus: async (query, payload, setToaster) => {
    try {
      set({ updateLoading: true, error: null });
      const response = await updateOrder(query, payload);
      set({ updateLoading: false });
      setToaster("Update Order", "Order Moved Successfully", "success");
    } catch (error) {
      if (error.response.status == "400") {
        setToaster("Update Order", error.response.data.message, "danger");
      } else {
        setToaster("Update Order", "Fail to update", "danger");
      }
      set({ error: error.message, updateLoading: false });
    }
  },
}));

export const useOpenOrdersStore = create((set) => ({
  openOrderData: [],
  openOrdersLoading: false,
  downloading: false,
  error: null,
  fetchOpenOrdersData: async (query) => {
    try {
      set({ openOrdersLoading: true, error: null });
      const response = await openOrders(query);
      set({ openOrderData: response.data, openOrdersLoading: false });
    } catch (error) {
      set({ error: error.message, openOrdersLoading: false });
    }
  },
  getOpenOrdersDownload: async (query, setToaster) => {
    try {
      set({ caseDataToLoading: true, error: null });
      const response = await openOrdersDownload(query);
      setToaster(
        "Download Orders",
        "Email with Orders Attachment sent successfully",
        "success"
      );
      set({ caseDataToLoading: false });
    } catch (error) {
      setToaster("Download Orders", "Orders download failed", "danger");
      set({ error: error.message, caseDataToLoading: false });
    }
  },
}));

export const useRecentOrdersStore = create((set) => ({
  recentOrderData: [],
  recentOrdersLoading: false,
  postLoading: false,
  error: null,
  fetchRecentOrdersData: async (payload) => {
    try {
      set({ recentOrdersLoading: true, error: null });
      const response = await recentOrderData(payload);
      set({ recentOrderData: response.data, recentOrdersLoading: false });
    } catch (error) {
      set({ error: error.message, recentOrdersLoading: false });
    }
  },
  assignRecentOrders: async (payload, setToaster) => {
    const callFunction = payload?.map((item) => {
      return recentOrderAssign(item);
    });
    try {
      Promise.all(callFunction)
        .then((data) => {
          setToaster(
            "Order Assigned",
            "Orders Assigned Successfully",
            "success"
          );
        })
        .catch((error) => {
          if (error.response.status) {
            setToaster(
              "Order Assignment",
              "One or more cases could not be assigned due to no available slots. The page will refresh with the latest data.",
              "danger"
            );
          } else {
            setToaster("Order Assignment", "Unable to assign", "danger");
          }
        });
    } catch (error) {
      set({ error: error.message, errorUpdate: true });
    }
  },
}));

export const useAssignedOrdersStore = create((set) => ({
  assignedOrderData: [],
  doctorData:[],
  assignedOrdersLoading: false,
  downloading: false,
  error: null,
  roleData: [],
  fetchAssignedOrdersData: async (query) => {
    try {
      set({ assignedOrdersLoading: true, error: null });
      const response = await assignedDoctors(query);
      set({ assignedOrderData: response.data, assignedOrdersLoading: false });
    } catch (error) {
      set({ error: error.message, assignedOrdersLoading: false });
    }
  },
  fetchDoctorRoleData: async () => {
    try {
      set({ caseDataToLoading: true, error: null });
      const response = await getReps("doctor");
      set({ doctorData:response.data, caseDataToLoading: false });
    } catch (error) {
      set({ error: error.message, caseDataToLoading: false });
    }
  },
  fetchRoleData: async (role) => {
    try {
      set({ caseDataToLoading: true, error: null });
      const response = await getReps(role);
      set({ roleData:response.data, caseDataToLoading: false });
    } catch (error) {
      set({ error: error.message, caseDataToLoading: false });
    }
  },
}));

export const useGhostOrdersStore = create((set) => ({
  ghostOrderData: [],
  ghostOrdersLoading: false,
  postLoading: false,
  error: null,
  fetchGhostOrdersData: async (page) => {
    try {
      set({ ghostOrdersLoading: true, error: null });
      const response = await ghostOrders(page);
      set({ ghostOrderData: response.data, ghostOrdersLoading: false });
    } catch (error) {
      set({ error: error.message, ghostOrdersLoading: false });
    }
  },
  assignGHostOrders: async (payload, setToaster) => {
    const callFunction = payload?.map((payloadData) => {
      return recentOrderAssign(payloadData);
    });
    try {
      Promise.all(callFunction)
        .then((data) => {
          setToaster(
            "Order Assigned",
            "Orders Assigned Successfully",
            "success"
          );
        })
        .catch((error) => {
          if (error.response.status) {
            setToaster(
              "Order Assignment",
              "One or more cases could not be assigned due to no available slots. The page will refresh with the latest data.",
              "danger"
            );
          } else {
            setToaster("Order Assignment", "Unable to assign", "danger");
          }
        });
    } catch (error) {
      set({ error: error.message, errorUpdate: true });
    }
  },
}));

export const useUpdateWarehousePincode = create((set) => ({
  updateLoading: false,
  updateWarehousePincode: async (payload, setToaster) => {
    try {
      set({ updateLoading: true, error: null });
      const response = await warehousePincode(payload);
      set({ updateLoading: false });
      setToaster("Update Warehouse pincode", "Warehouse pincode Updated", "success");
    } catch (error) {
      if (error.response.status == "400") {
        setToaster("Update Warehouse pincode", error.response.data.message, "danger");
      } else {
        setToaster("Update Warehouse pincode", "Fail to update", "danger");
      }
      set({ error: error.message, updateLoading: false });
    }
  },
  downloadData: async (email, setToaster) => {
    try {
      set({ caseDataToLoading: true, error: null });
      const response = await warehouseDownloadPincode(email);
      setToaster(
        "Warehouse Pincode",
        "Data is Downloaded",
        "success"
      );
    } catch (error) {
      setToaster(
        "Warehouse Pincode",
        error.response.data.message||"Failed to Download Data",
        "danger"
      );
      set({ error: error.message, caseDataToLoading: false });
    }
  },
}));

export const useReturnOrderStore = create((set) => ({
  returnOrderData: [],
  returnOrdersLoading: false,
  error: null,
  fetchReturnOrdersData: async (query) => {
    try {
      set({ returnOrdersLoading: true, error: null });
      const response = await getReturnOrderDetails(query);
      set({
        returnOrderData: response.data,
        returnOrdersLoading: false,
      });
    } catch (error) {
      set({
        error: error.response?.data?.message || error.message,
        returnOrdersLoading: false,
      });
    }
  },
}));

